module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "title": _vm.title
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "modal-body",
    slot: "modal-body"
  }, [_c('alert', {
    attrs: {
      "type": _vm.type.type
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('icon', {
    attrs: {
      "name": _vm.type.icon,
      "scale": "2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": _vm.alertType.type,
      "width": "480px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertShow),
      callback: function($$v) {
        _vm.alertShow = $$v
      },
      expression: "alertShow"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-right": "35px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('icon', {
    attrs: {
      "name": _vm.alertType.icon,
      "scale": "2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('strong', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertTitle),
      expression: "alertTitle"
    }]
  }, [_vm._v(_vm._s(_vm.alertTitle))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertText),
      expression: "alertText"
    }]
  }, [_vm._v(_vm._s(_vm.alertText))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d2a407ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/modalMessage/ModalMessage.vue
// module id = 1555
// module chunks = 2